
export const resolveDatePreset = preset => {
  const now = new Date();

  // All boundaries below use the browser's LOCAL calendar day consistently,
  // for every preset, so "today"/"7d"/etc. never disagree on which day is "today".
  const startOfDay = date => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const endOfDay = date => {
    const d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return d;
  };

  const addDays = (date, days) => {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  };

  switch (preset) {
    case "today": {
      return {
        fromDate: startOfDay(now).getTime(),
        toDate: now.getTime()
      };
    }
    case "yesterday": {
      const yesterday = addDays(now, -1);
      return {
        fromDate: startOfDay(yesterday).getTime(),
        toDate: endOfDay(yesterday).getTime()
      };
    }
    case "lastWeek": {
      const day = now.getDay(); // 0=Sun
      const daysToLastMonday = day === 0 ? 6 : day - 1 + 7;
      const lastMonday = addDays(now, -daysToLastMonday);
      const lastSunday = addDays(lastMonday, 6);
      return {
        fromDate: startOfDay(lastMonday).getTime(),
        toDate: endOfDay(lastSunday).getTime()
      };
    }
    case "thisMonth": {
      const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      return {
        fromDate: startOfDay(firstOfMonth).getTime(),
        toDate: now.getTime()
      };
    }
    case "7d": {
      return {
        fromDate: startOfDay(addDays(now, -7)).getTime(),
        toDate: now.getTime()
      };
    }
    case "30d": {
      return {
        fromDate: startOfDay(addDays(now, -30)).getTime(),
        toDate: now.getTime()
      };
    }
    default: {
      return {
        fromDate: startOfDay(addDays(now, -7)).getTime(),
        toDate: now.getTime()
      };
    }
  }
};

// Minutes to add to local time to reach UTC. Sent to the backend so day-bucketing/labeling
// aligns with the user's local calendar day instead of hard-coded UTC.
export const getTimezoneOffsetMinutes = () => new Date().getTimezoneOffset();
